import React from 'react'
import PropTypes from 'prop-types'
import css from './build-filter.css'

const BuildFilter = ({
  arrToFilter,
  defaultOption,
  filterLabel,
  onChange,
  value,
}) => (
  <select
    className={css.select}
    value={value}
    onChange={onChange}
  >
    <option value="">{defaultOption}</option>
    {arrToFilter.map(item => (
      <option key={item.id} value={item.id}>
        {item[filterLabel]}
      </option>
    ))}
  </select>
)

BuildFilter.propTypes = {
  arrToFilter: PropTypes.arrayOf(PropTypes.object),
  defaultOption: PropTypes.string.isRequired,
  filterLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
}

export default BuildFilter



// WEBPACK FOOTER //
// ./src/components/sitewide/Filter/BuildFilter.js